export default __webpack_public_path__ + "static/media/scatCloud.172d6c44.jpg";